export default {"src":"/_next/static/media/qsp.e73f095a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};